import * as React from 'react';
import classnames from 'classnames';

import './style.scss';

interface IErrorPageProps {}

interface IErrorPageState {}

export default class ErrorPage extends React.Component<IErrorPageProps, IErrorPageState> {
  render() {
    return (
      <div className={classnames('error-page')}>
        <section className={classnames('error-page__error-block')}>
          <p className={classnames('error-page__error-block__error-code')}>404</p>
          <p className={classnames('error-page__error-block__error-title')}>PAGE NOT FOUND</p>
          <div className={classnames('error-page__error-block__error-info')}>
            <p>The page you are looking for has expired, was moved, renamed or does not exist.</p>
            <p>Please contact your administrator for further assistance.</p>
          </div>
        </section>
      </div>
    );
  }
}
